subscription homeNumber($homeNumberId: ID!, $tz: String) {
  homeNumber(id: $homeNumberId) {
    id
    label
    formattedNumber
    number
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      isCurrent
      last
    }
    archivedAt(tz: $tz)
    archivingTeacher {
      id
      first
      isCurrent
      last
    }
    blockedAt(tz: $tz)
    blockingTeacher {
      id
      first
      isCurrent
      last
    }
    conversations {
      teacherPhoneNumber {
        id
        displayName
      }
    }
  }
}
